import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getUserEmail } from '@/services/authentication';
import { hubspotPretrialFirstLogin } from '@/services/hubspotAccountCreationService';
import { hubspotPretrialRequest } from '../freeTrialActions';

export default function HubspotPretrialRedirect() {
    const navigate = useHistory();
    const dispatch = useDispatch();

    const { search } = window.location;
    const params = new URLSearchParams(search);
    const signupSessionId = params.get('session_id');
    const email = params.get('email')
   

    const firstLogin = (signupSessionId: string, email: string) => {
        dispatch(hubspotPretrialRequest({signupSessionId, email}));
    };

    useEffect(() => {
        try {
            if (signupSessionId && email) {
                firstLogin(signupSessionId, email);
            } else {
                console.error('Missing signupSessionId or email');
            }
            navigate.push('/');
        } catch (err) {
            console.log(err);
            navigate.push('/');
        }
    }, []);

    return <></>;
}
